import React, { useEffect, useState } from "react";
import { getProvinces, getWards } from "api/LocationInfo";
import { addCustomerDeliveryAddress, updateCustomerDeliveryAddress } from "api/CustomerDeliveries";
import { toast } from "react-toastify";

interface AddAddressModalProps {
    open: boolean;
    onClose: () => void;
    onSave: () => void;
    editingAddress?: any | null;
}

export default function AddAddressModal({ open, onClose, onSave, editingAddress }: AddAddressModalProps) {
    const [provinces, setProvinces] = useState<any[]>([]);
    // const [districts, setDistricts] = useState<any[]>([]);
    const [wards, setWards] = useState<any[]>([]);

    const [form, setForm] = useState({
        name: "",
        phone: "",
        province: "",
        // district: "",
        ward: "",
        address: "",
        isDefault: false,
    });

    useEffect(() => {
        if (open) {
            getProvinces().then(setProvinces).catch(console.error);
        }
    }, [open]);

    // useEffect(() => {
    //     if (form.province) {
    //         getDistricts(form.province).then(setDistricts).catch(console.error);
    //         // setForm(prev => ({ ...prev, district: "", ward: "" }));
    //         setWards([]);
    //     }
    // }, [form.province]);

    useEffect(() => {
        if (form.province) {
            getWards(form.province).then(setWards).catch(console.error);
            // setForm(prev => ({ ...prev, ward: "" }));
        }
    }, [form.province]);

    useEffect(() => {
        if (!open) return;

        if (!editingAddress) {
            setForm({
                name: "",
                phone: "",
                province: "",
                // district: "",
                ward: "",
                address: "",
                isDefault: false,
            });

            // setDistricts([]);
            setWards([]);
            return;
        }

        if (provinces.length === 0) return;

        const load = async () => {
            const province = provinces.find(
                p => p.name === editingAddress.province
            );

            if (!province) return;

            // const districtList = await getDistricts(province.id);

            // const district = districtList.find(
            //     d => d.name === editingAddress.district
            // );

            let wardList: any[] = [];

            if (province) {
                wardList = await getWards(province.code);
            }

            const ward = wardList.find(
                w => w.name === editingAddress.ward
            );



            // setDistricts(districtList);
            setWards(wardList);

            setForm({
                name: editingAddress.name,
                phone: editingAddress.phone,
                province: String(province.code),
                // district: district ? String(district.id) : "",
                ward: ward ? ward.code : "",
                address: editingAddress.address,
                isDefault: editingAddress.is_default,
            });
        };

        load();
    }, [editingAddress, provinces]);

    if (!open) return null;


    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
    ) => {
        const { name, value, type } = e.target;
        const checked = (e.target as HTMLInputElement).checked;

        if (type === "checkbox") {
            setForm(prev => ({
                ...prev,
                [name]: checked,
            }));
            return;
        }

        if (name === "province") {
            setForm(prev => ({
                ...prev,
                province: value,
                // district: "",
                ward: "",
            }));
            // setDistricts([]);
            setWards([]);
            return;
        }

        // if (name === "district") {
        //     setForm(prev => ({
        //         ...prev,
        //         district: value,
        //         ward: "",
        //     }));
        //     setWards([]);
        //     return;
        // }

        setForm(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        // Validate
        if (!form.name.trim()) {
            toast.error("Vui lòng nhập họ và tên", {
                position: "bottom-right",
            });
            return;
        }

        if (!form.phone.trim()) {
            toast.error("Vui lòng nhập số điện thoại", {
                position: "bottom-right",
            });
            return;
        }

        const phoneRegex = /^(0|\+84)[0-9]{9,10}$/;

        if (!phoneRegex.test(form.phone.trim())) {
            toast.error("Số điện thoại không hợp lệ", {
                position: "bottom-right",
            });
            return;
        }

        if (!form.province) {
            toast.error("Vui lòng chọn Tỉnh/Thành phố", {
                position: "bottom-right",
            });
            return;
        }

        if (!form.ward) {
            toast.error("Vui lòng chọn Phường/Xã", {
                position: "bottom-right",
            });
            return;
        }

        try {
            const provinceName = provinces.find(p => p.code === form.province)?.name || "";
            // const districtName = districts.find(d => d.id === Number(form.district))?.name || "";
            const wardName = wards.find(w => String(w.code) === String(form.ward))?.name || "";

            const payload = {
                name: form.name,
                phone: form.phone,
                province: provinceName,
                // district: districtName,
                ward: wardName,
                address: form.address,
                is_default: form.isDefault,
            };

            if (editingAddress) {
                await updateCustomerDeliveryAddress(editingAddress.id, payload);
            } else {
                await addCustomerDeliveryAddress(payload);
            }
            onSave();
            onClose();
        } catch (error) {
            console.error("Failed to add address:", error);
            toast.error("Thêm địa chỉ thất bại. Vui lòng thử lại.", {
                position: "bottom-right",
            });
        }
    };

    return (
        <div
            role="presentation"
            className="styles_modalItem__YKbSY"
            style={{ position: "fixed", inset: 0, zIndex: 1300 }}
        >
            {/* backdrop */}
            <div
                aria-hidden="true"
                style={{
                    position: "fixed",
                    inset: 0,
                    backgroundColor: "rgba(0,0,0,.5)",
                }}
                onClick={onClose}
            />

            <div
                className="styles_auth_modal_content_checkout__UhpEG"
                style={{ width: 580, margin: "60px auto" }}
            >
                <header className="styles_auth_modal_title__tQ0WQ">
                    {editingAddress ? "Cập nhật địa chỉ" : "Thêm địa chỉ nhận hàng"}
                </header>

                {/* FORM */}
                <form
                    onSubmit={handleSubmit}
                >
                    <div className="MuiGrid-root styles_formGrid__bgm3n MuiGrid-container">

                        {/* Họ tên + SĐT */}
                        <div className="MuiGrid-root styles_formGridFieldName___9PUk MuiGrid-item MuiGrid-grid-xs-12">
                            <div className="MuiFormControl-root MuiFormControl-fullWidth">
                                <div className="MuiInputBase-root MuiOutlinedInput-root sc-242007b2-0 cWOwtw styles_input__a0YjR MuiInputBase-formControl">
                                    <input
                                        name="name"
                                        required
                                        placeholder="Họ và tên khách hàng*"
                                        type="text"
                                        value={form.name}
                                        onChange={handleChange}
                                        className="MuiInputBase-input MuiOutlinedInput-input"
                                    />
                                </div>
                            </div>

                            <div className="MuiFormControl-root MuiFormControl-fullWidth">
                                <div className="MuiInputBase-root MuiOutlinedInput-root sc-242007b2-0 cWOwtw styles_input__a0YjR MuiInputBase-formControl">
                                    <input
                                        name="phone"
                                        required
                                        placeholder="Số điện thoại*"
                                        type="text"
                                        value={form.phone}
                                        onChange={handleChange}
                                        className="MuiInputBase-input MuiOutlinedInput-input"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Province / District / Ward */}
                        <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12">
                            <div style={{ margin: "auto" }}>
                                <div className="MuiGrid-root styles_container__jpKDg MuiGrid-container">

                                    {/* Province */}
                                    <div className="MuiGrid-root styles_addressWrapper__kN0xP MuiGrid-item MuiGrid-grid-xs-12">
                                        <div className="MuiFormControl-root MuiTextField-root styles_select__oxdi5">
                                            <div className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd">
                                                <select
                                                    name="province"
                                                    required
                                                    value={form.province}
                                                    onChange={handleChange}
                                                    className="MuiSelect-root MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input"
                                                >
                                                    <option value="">Tỉnh/Thành phố</option>
                                                    {provinces.map(p => (
                                                        <option key={p.code} value={p.code}>{p.name}</option>
                                                    ))}
                                                </select>
                                            </div>
                                        </div>
                                    </div>

                                    {/* District */}
                                    <div className="MuiGrid-root styles_addressWrapper__kN0xP MuiGrid-item MuiGrid-grid-xs-12">
                                        {/* <div className="MuiGrid-root MuiGrid-grid-sm-6">
                                            <div className="MuiFormControl-root MuiTextField-root styles_select__oxdi5">
                                                <div className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd">
                                                    <select
                                                        name="district"
                                                        value={form.district}
                                                        onChange={handleChange}
                                                        className="MuiSelect-root MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input"
                                                        disabled={!form.province}
                                                    >
                                                        <option value="">Quận/Huyện</option>
                                                        {districts.map(d => (
                                                            <option key={d.id} value={d.id}>{d.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div> */}

                                        {/* Ward */}
                                        <div className="MuiGrid-root MuiGrid-grid-sm-12">
                                            <div className="MuiFormControl-root MuiTextField-root styles_select__oxdi5">
                                                <div className="MuiInputBase-root MuiOutlinedInput-root MuiInputBase-formControl MuiInputBase-adornedEnd MuiOutlinedInput-adornedEnd">
                                                    <select
                                                        name="ward"
                                                        required
                                                        value={form.ward}
                                                        onChange={handleChange}
                                                        disabled={!form.province}
                                                        className="MuiSelect-root MuiSelect-select MuiSelect-outlined MuiInputBase-input MuiOutlinedInput-input"
                                                    >
                                                        <option value="">Phường/Xã</option>
                                                        {wards.map(w => (
                                                            <option key={w.code} value={w.code}>{w.name}</option>
                                                        ))}
                                                    </select>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Address */}
                            <div className="MuiGrid-root styles_formGridFieldName___9PUk MuiGrid-item w-full mt-2">
                                <div className="MuiFormControl-root MuiFormControl-fullWidth">
                                    <div className="MuiInputBase-root MuiOutlinedInput-root sc-242007b2-0 cWOwtw styles_input__a0YjR MuiInputBase-formControl">
                                        <input
                                            name="address"
                                            placeholder="Địa chỉ nhà thuốc/phòng khám"
                                            type="text"
                                            value={form.address}
                                            onChange={handleChange}
                                            className="MuiInputBase-input MuiOutlinedInput-input"
                                        />
                                    </div>
                                </div>
                            </div>

                            <div
                                className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12"
                                style={{ color: "rgb(121, 121, 121)" }}
                            >
                                <p className="MuiTypography-root MuiTypography-body1">
                                    <label className="MuiFormControlLabel-root">
                                        <span
                                            className={
                                                "MuiButtonBase-root MuiIconButton-root jss1 MuiCheckbox-root styles_checkbox___9JzD MuiCheckbox-colorSecondary MuiIconButton-colorSecondary " +
                                                (form.isDefault ? "jss2 Mui-checked" : "")
                                            }
                                        >
                                            <span className="MuiIconButton-label">
                                                <input
                                                    className="jss4 pointer-events-none"
                                                    name="isDefault"
                                                    type="checkbox"
                                                    checked={form.isDefault}
                                                    onChange={handleChange}
                                                />
                                                {form.isDefault ? (
                                                    <svg className="MuiSvgIcon-root" focusable="false" viewBox="0 0 24 24" aria-hidden="true">
                                                        <path d="M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                                                    </svg>
                                                ) :
                                                    <svg
                                                        className="MuiSvgIcon-root"
                                                        focusable="false"
                                                        viewBox="0 0 24 24"
                                                        aria-hidden="true"
                                                    >
                                                        <path d="M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z" />
                                                    </svg>
                                                }

                                            </span>
                                            <span className="MuiTouchRipple-root"></span>
                                        </span>

                                        <span className="MuiTypography-root MuiFormControlLabel-label MuiTypography-body1">
                                            Đặt làm địa chỉ mặc định
                                        </span>
                                    </label>
                                </p>
                            </div>

                            {/* Buttons */}
                            <div className="MuiGrid-root MuiGrid-item MuiGrid-grid-xs-12">
                                <div className="styles_btnBox__zQz8x">
                                    <button onClick={onClose} type="button" className="styles_btn_cancel__WiBEo">
                                        Hủy bỏ
                                    </button>

                                    <button type="submit" className="styles_btn_register__qgw1K">
                                        Xác nhận
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </div>
    );
}